import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { invoiceAPI } from 'redux/invoiceAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { LocalDate } from '@payer-admin-ui/api/src/external/java/LocalDate';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import { fetchInvoice, upsertInvoiceInListView } from '../invoicesGlobalState';
import { MerchantAdminDispatch } from '../../../../redux/store';

export const creditInvoiceFully = createAsyncThunk<
  void,
  { invoiceNumber: number; invoiceDate?: LocalDate },
  { dispatch: MerchantAdminDispatch }
>('invoices/actions/CreditInvoiceFullyModal/credit', async ({ invoiceNumber, invoiceDate }, { dispatch }) => {
  const createdCreditInvoice = await invoiceAPI.actions.creditInvoiceFully({ invoiceNumber, invoiceDate });
  dispatch(upsertInvoiceInListView(createdCreditInvoice));
  dispatch(fetchInvoice({ invoiceNumber }));
  dispatch(
    showSnackbar(i18n.t('invoices.actions.creditInvoiceFully.success', { invoiceNumber }), {
      severity: 'success',
    }),
  );
});

export type CreditInvoiceFullyModalState = {
  [invoiceNumber: string]: FetchingState | undefined;
};
const initialState: CreditInvoiceFullyModalState = {};
const creditInvoiceFullyModalSlice = createSlice({
  name: 'invoices/actions/CreditInvoiceFullyModal',
  initialState,
  reducers: {
    reset: (state, { payload: { invoiceNumber } }) => {
      delete state[invoiceNumber];
    },
  },
  extraReducers: builder => {
    builder.addCase(creditInvoiceFully.pending, (state, { meta: { arg } }) => {
      state[arg.invoiceNumber] = { isFetching: true, success: undefined, error: null };
    });
    builder.addCase(creditInvoiceFully.fulfilled, (state, { meta: { arg } }) => {
      state[arg.invoiceNumber] = { isFetching: false, success: true, error: null };
    });
    builder.addCase(creditInvoiceFully.rejected, (state, { meta: { arg }, error }) => {
      state[arg.invoiceNumber] = { isFetching: false, success: false, error };
    });
  },
});

export const {
  actions: { reset },
  reducer: creditInvoiceFullyModalReducer,
} = creditInvoiceFullyModalSlice;
